export const activityNavigationOrigins = {
  activities: 'activities',
  weeklyPlanner: 'weekly planner',
} as const;

const MAX_WIDGET_ENTRIES = 5;

export const WIDGET_MAX_WIDTH = '1280px';

export const WIDGET_MAX_HEIGHT = '353px';

export const trimWidgetEntryList = (entries: any[] | undefined, size: number = MAX_WIDGET_ENTRIES) => {
  if (!entries) return [];

  return entries.slice(0, size);
};
